<script>
  'use strict'
  import { _currentTheme } from '../store/store.js';
  import { themesCollection, setThemeToLocal, setDefaultTheme } from "../shared/theme.js";

  // -------------------------------------------------
  const colorCollection = [
    { cssProperty: 'background-color', name: 'BACKGROUND'},
    { cssProperty: 'section-color', name: 'SECTION'},
    { cssProperty: 'font-color', name: 'FONT'},
    { cssProperty: 'hightlight-color', name: 'HIGHLIGHT'},
    { cssProperty: 'grid-color', name: 'GRID'},
  ]

  // -------------------------------------------------
  function changeColor(event) {
    const key = event.target.name;
    const value = event.target.value;

    document.documentElement.style.setProperty(`--${key}`, `${value}`);
    themesCollection[$_currentTheme][key] = value;
    setThemeToLocal(themesCollection);
  }

  function getColor(c) {
    const currentColor = getComputedStyle(document.documentElement).getPropertyValue(`--${c}`);
    return currentColor;
  }

</script>

<h3>Custom color theme</h3>
<div class="custom-color">
  {#each colorCollection as color}
    <div>
      <label for="{color.cssProperty}">{color.name}</label>
      <input name="{color.cssProperty}" type="color" value="{getColor(color.cssProperty)}" on:change="{changeColor}">
    </div>
  {/each}
</div>
<button on:click="{() => setDefaultTheme($_currentTheme)}">SET DEFAULT THEME</button>


<style>
  input[type=color] {
    padding: 0;
    width: 100px;
    height: 100px;
  }

  .custom-color {
    display: flex;
    gap: 12px;
  }
</style>